import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  ButtonV2,
  LabraToolTipV2,
  ModalConfirmV2,
  ModalSizeVariants,
} from '@labrav/react-components'
import { useStyles } from './CreateMeteringBase.styles'
import { Typography } from '@mui/material'

export default function CreateMeteringBase({
  showModal,
  updateModalVisibility,
  updateCurrentOpenModal,
}: {
  showModal: boolean
  updateModalVisibility: () => void
  updateCurrentOpenModal: (key: string) => void
}) {
  return (
    <div data-testId="createMetering-BaseModal">
      <ModalConfirmV2
        title={'Create metering record'}
        icon={<FontAwesomeIcon style={{ height: '16px' }} icon={faPlus} />}
        content={
          <CreateMeteringBaseContent
            updateCurrentOpenModal={updateCurrentOpenModal}
          />
        }
        open={showModal}
        hideAcceptButton
        hideCancelButton
        onAccept={() => void 0}
        onDecline={() => updateModalVisibility()}
        variant={ModalSizeVariants.large}
      />
    </div>
  )
}

const CreateMeteringBaseContent = ({
  updateCurrentOpenModal,
}: {
  updateCurrentOpenModal: (key: string) => void
}) => {
  const { classes } = useStyles()
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <Typography className={classes.title}>
          Upload multiple metering records via CSV/Excel file.
        </Typography>
        <Typography className={classes.recommendations}>
          (Recommended for 10+ records.)
        </Typography>
        <LabraToolTipV2 tooltipPlacement="bottom">
          <ButtonV2
            data-testid="createMetering-UploadModalButton"
            onClick={() =>
              updateCurrentOpenModal('CreateMeteringFormatSelector')
            }
          >
            Upload metering record
          </ButtonV2>
        </LabraToolTipV2>
      </div>
      <div
        className={classes.verticalDivider}
        data-testid="vertical-divider"
      ></div>
      <div className={classes.content}>
        <Typography className={classes.title}>
          Submit individual metering records via web form.
        </Typography>
        <Typography className={classes.recommendations}>
          (Recommended for 1-10 records.)
        </Typography>
        <ButtonV2
          data-testid="createMetering-MeteringFormButton"
          onClick={() => updateCurrentOpenModal('CreateMeteringForm')}
        >
          Enter record using form
        </ButtonV2>
      </div>
    </div>
  )
}
